import { Alert } from "react-bootstrap";
import { useTranslation } from "react-i18next";
import { useExplorerConnectionLimit } from "../../hooks/useExplorerConnectionLimit";
import { getExplorerLimitCounterMessage } from "../../utils/explorerConnectionLimitCopy";

type Props = {
  className?: string;
  variant?: "info" | "warning";
};

/** Explorer weekly connection budget — same reset timestamp as limit notices and modals. */
export function ExplorerConnectionLimitCounter({
  className = "mb-3",
  variant = "info",
}: Props) {
  const { t, i18n } = useTranslation();
  const { isExplorer, used, limit, weekResetsUtc, canPerformConnectionAction } =
    useExplorerConnectionLimit();

  if (!isExplorer) return null;

  const locale = i18n.resolvedLanguage ?? i18n.language;
  const message = getExplorerLimitCounterMessage(t, {
    locale,
    weekResetsUtc,
    used,
    limit,
  });

  return (
    <Alert
      variant={canPerformConnectionAction ? variant : "warning"}
      className={`border-0 shadow-sm rounded-3 mb-0 ${className}`.trim()}
    >
      <div className="small fw-medium">{message}</div>
    </Alert>
  );
}
